import React, { useState, useEffect } from "react";
import ThirdBar from "../../../../components/AdminComponents/ThirdBar";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import {
  SecondaryNavTNCommunications,
  SettingsMenu,
} from "../../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../../components/AdminComponents/SecondaryNav2";
import {
  EditTwoTone,
  HistoryOutlined,
  UserOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../../api/Axios";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
import { Avatar, Switch, Table, Pagination, Spin } from "antd";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
const CustomNotificationsLogs = () => {
  const { id } = useParams();

  const thirdMenuData = [
    {
      path: `/access-manager/notifications/custom-notifications/edit/${id}`,
      name: "Edit Custom Notification",
      icon: (
        <EditTwoTone
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
    {
      path: `/access-manager/notifications/custom-notifications/logs/${id}`,
      name: "Audit Logs",
      icon: (
        <HistoryOutlined
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [itemsLength, setItemsLength] = useState();
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    active: true,
    url: `/customnotificationuser/${id}/`,
    search: "",
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, url, search, active } = filterData;
  const LoadContacts = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await axiosInstance.get(passUrl);

        setItemsLength(res.data?.count);

        setData(res.data?.results);
        setLoading(false);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setLoading(false);
        }
        //console.log(err);
      }
    }
  };
  useEffect(() => {
    LoadContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const [formData, setFormData] = useState();
  useEffect(() => {
    const LoadUserData = async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get(`/customnotification/${id}/`);
        setFormData(res.data?.notification_content || "");
        //console.log(res.data);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        setLoading(false);
      }
    };
    LoadUserData();
  }, [id]);
  const renderStatus = (text, record) => {
    if (record.read) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  const columns = [
    {
      title: capitalizeWords("READ BY"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar
            alt={record?.user?.full_name}
            src={record?.user?.profile_pic || null}
            icon={!record?.user?.profile_pic && <UserOutlined />}
            size="small"
          />
          <span style={{ marginLeft: 8 }}>{record?.user?.full_name}</span>
        </div>
      ),
    },

    {
      title: capitalizeWords("EMAIL"),
      dataIndex: "templateUsed",
      key: "templateUsed",
      width: 225,
      render: (_, record) => <span>{record?.user?.email}</span>,
    },
    {
      title: capitalizeWords("Client Name"),
      dataIndex: "client_name",
      key: "client_name",
      width: 175,
      render: (_, record) => <span>{record?.user?.client_name}</span>,
    },
    {
      title: capitalizeWords("STATUS"),
      dataIndex: "read",
      key: "read",
      render: renderStatus,
      width: 125,
      align: "center",
    },
    {
      title: capitalizeWords("SENT TIME"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (text, record) => {
        const date = new Date(record?.created_at);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";

        if (record.created_at) {
          return `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;
        } else {
          return "No data recorded";
        }
      },
    },
    {
      title: capitalizeWords("READ TIME"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (text, record) => {
        const date = new Date(record?.read_at);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";

        if (record.read_at) {
          return `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;
        } else {
          return "No data recorded";
        }
      },
    },
  ];

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
    console.log(event);
  };
  return (
    <Sidebar props={SettingsMenu}>
      <SecondaryNav menuItems={SecondaryNavTNCommunications} />
      <ThirdBar menuItems={thirdMenuData} />
      <CommonTopDetails
        title={active ? `${formData} - Log Summary` : "Inactive Logs"}
        titleSuffix={`${itemsLength || 0} Log(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        marginPass="15px"
        customContent={
          <Switch
            style={{
              backgroundColor: active ? "#50C878" : "#FF0000",
              minWidth: "90px",
            }}
            checked={active}
            // onChange={handleSwitchChange}
            disabled={loading}
            checkedChildren="READ BY"
            unCheckedChildren="INACTIVE"
          />
        }
      />

      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={data}
          size="small"
          rowKey="id"
          bordered
          className="table-container"
          pagination={false}
          style={{ margin: "1rem" }}
          scroll={{
            y: `${remainingViewportHeight(36)}px`,
            x: 1000,
          }}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
    </Sidebar>
  );
};

export default CustomNotificationsLogs;
